import { plural } from '@cian/utils';

export const getTitle = (total: number): string => {
  return `${total} ` + plural(total, ['строительная компания', 'строительные компании', 'строительных компаний']);
};
